<template>
  <v-container class="pa-0">
    <v-row>
      <v-col :cols="selected === undefined ? '12' : '6'">
        <v-list>
          <v-list-item-group v-model="selected">
            <v-list-item
              v-for="player in playersData"
              :key="player.key"
            >
              <v-list-item-title>{{ player.name }}</v-list-item-title>
              <v-list-item-action>
                <v-icon>mdi-pencil</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col
        v-if="selected !== undefined"
        cols="6"
      >
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="playersData[selected].name"
                :rules="[rules.required]"
                :label="$t('profile.sections.common.name')"
                dense
                clearable
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="playersData[selected].city"
                :label="$t('status.city')"
                :append-icon="cityOther.length > 0 ? 'mdi-map-marker-multiple' : 'mdi-map-marker-question'"
                dense
                @input="resetOtherCity()"
                @click:append="setCityInfo()"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="playersData[selected].dpt"
                :label="$t('status.department')"
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="playersData[selected].lat"
                :label="$t('profile.sections.player.lat')"
                dense
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="playersData[selected].lng"
                :label="$t('profile.sections.player.lng')"
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="playersData[selected].license"
                :label="$t('profile.sections.player.license')"
                readonly
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn
                color="success"
                :disabled="playersData[selected].name.length < 1"
                @click="updatePlayerData(playersData[selected].id)"
              >
                <v-icon class="mr-2">mdi-content-save-outline</v-icon>{{ $t("profile.sections.common.update") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Connectors
import { PlayerConnector } from "../Database/PlayerConnector.js";
const geoApi = require("../Tools/GeoApi");

export default {
  data() {
    return {
      playerConnector: new PlayerConnector(this.$store.state.user),
      selected: undefined,
      playersData: [],
      cityOther: [],
      cityIndex: 0,
      rules: {
        required: (value) => !!value || this.$t("field.required"),
      },
    };
  },
  mounted() {
    if (this.$store.state.user.socId != null) {
      this.getAllPlayers();
    }
  },
  methods: {
    getAllPlayers() {
      this.playerConnector
        .getAllPlayers()
        .then((players) => {
          // TODO: format in db server
          this.playersData = players.map((data) => {
            return {
              id: data.id_plyr,
              name: data.name,
              dpt: data.dpt,
              city: data.city,
              lat: parseFloat(data.lat),
              lng: parseFloat(data.lng),
              license: data.identifier,
            };
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setCityInfo() {
      if (this.cityOther.length > 0) {
        this.cityIndex++;

        if (this.cityIndex >= this.cityOther.length) {
          this.cityIndex = 0;
        }

        this.playersData[this.selected].city = this.cityOther[this.cityIndex].city;
        this.playersData[this.selected].dpt = this.cityOther[this.cityIndex].dpt;
        this.playersData[this.selected].lat = this.cityOther[this.cityIndex].lat;
        this.playersData[this.selected].lng = this.cityOther[this.cityIndex].lng;
      } else {
        const currentCity = this.playersData[this.selected].city;

        if (currentCity.length > 0) {
          geoApi
            .getCityInfo(currentCity)
            .then((response) => {
              if (response.length > 0) {
                if (response.length > 1) {
                  this.cityOther = response.map((elem) => {
                    return {
                      city: elem.nom,
                      dpt: elem.departement.nom,
                      lat: elem.centre.coordinates[1],
                      lng: elem.centre.coordinates[0],
                    };
                  });
                }

                // Write first result
                this.playersData[this.selected].city = response[0].nom;
                this.playersData[this.selected].dpt = response[0].departement.nom;
                this.playersData[this.selected].lat = response[0].centre.coordinates[1];
                this.playersData[this.selected].lng = response[0].centre.coordinates[0];
              } else {
                this.resetCity();
              }
            })
            .catch((err) => {
              console.error(err);
              this.resetCity();
            });
        } else {
          this.resetCity();
        }
      }
    },
    resetCity() {
      this.playersData[this.selected].city = "";
      this.playersData[this.selected].dpt = "";
      this.playersData[this.selected].lat = "";
      this.playersData[this.selected].lng = "";
    },
    resetOtherCity() {
      this.cityOther = [];
      this.cityIndex = 0;
    },
    updatePlayerData(pid) {
      if (this.playersData[this.selected].name.length > 0) {
        this.playerConnector.updatePlayer(this.playersData[this.selected], pid).catch((err) => {
          console.error(err);
        });
      }
    },
  },
};
</script>

<style></style>
